module.exports = __webpack_public_path__ + "static/media/кустики.cb4f77a1.jpg";